import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../ui/Button';
import type { HomeRoleAlert } from './homeTypes';

interface RoleAttentionModuleProps {
  alerts: HomeRoleAlert[];
}

const roleLabel: Record<string, string> = {
  organizer: 'Organizer',
  judge: 'Judge',
  club_admin: 'Club',
};

export const RoleAttentionModule: React.FC<RoleAttentionModuleProps> = ({ alerts }) => {
  const navigate = useNavigate();
  const top = [...alerts]
    .sort((a, b) => (b.urgency ?? 0) - (a.urgency ?? 0))
    .slice(0, 2);
  if (!top.length) return null;

  return (
    <section className="py-4" aria-label="Role attention">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-3">
        {top.map((alert) => (
          <div
            key={alert.id}
            className="flex flex-col sm:flex-row sm:items-center gap-3 bg-orange-950/30 border border-orange-500/25 px-4 py-3 sm:px-5"
            role="status"
          >
            <div className="min-w-0 flex-1">
              <p className="text-[11px] uppercase tracking-[0.12em] text-orange-400/90 mb-1">
                {roleLabel[alert.role] || alert.role}
              </p>
              <p className="text-white font-medium text-sm sm:text-base">{alert.title}</p>
              {alert.body ? <p className="text-gray-400 text-sm mt-0.5">{alert.body}</p> : null}
            </div>
            <Button type="button" variant="secondary" size="sm" onClick={() => navigate(alert.href)}>
              {alert.cta_label}
            </Button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default RoleAttentionModule;
